class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this), { passive: true });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape, { passive: true });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange, { passive: true });
  }

  static toggleActiveFacets(disable = true) {
    // document.querySelectorAll('.js-facet-remove').forEach((element) => {
    //   element.classList.toggle('disabled', disable);
    // });

    document.querySelectorAll(".ml_filter").forEach((el) => {
      const length = el.querySelectorAll(".ml_filter_body.expand")?.length > 0;
      if (length) {
        el.querySelector(".ml_filter_header")?.querySelector("svg")?.classList.add("expand_icon");
      }
    })

  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
      
      const toggleFilter = document.getElementById("Filter_Mobile_btn");
      toggleFilter?.click();
    } 
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      if (document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`))
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.element = {
      min: this.querySelector("#MLPriceMin"),
      max: this.querySelector("#MLPriceMax"),
    }

    this.dragData = {
      min: {
        drag: false,
        pos: 0,
        start: 0
      },
      max: {
        drag: false,
        pos: 0,
        start: 0
      }
    }

    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this), { passive: true }));

    const minlabel = this.element?.min?.querySelector("label")
    const maxlabel = this.element?.max?.querySelector("label")

    minlabel?.addEventListener("mousedown", this.handleStartDrag.bind(this, "min"), { passive: true });
    maxlabel?.addEventListener("mousedown", this.handleStartDrag.bind(this, "max"), { passive: true });
    minlabel?.addEventListener("touchstart", this.handleStartDrag.bind(this, "min"), { passive: true });
    maxlabel?.addEventListener("touchstart", this.handleStartDrag.bind(this, "max"), { passive: true });

    minlabel?.addEventListener("mouseup", this.handleStopDrag.bind(this, "min"), { passive: true });
    maxlabel?.addEventListener("mouseup", this.handleStopDrag.bind(this, "max"), { passive: true });;
    minlabel?.addEventListener("touchend", this.handleStopDrag.bind(this, "min"), { passive: true });
    maxlabel?.addEventListener("touchend", this.handleStopDrag.bind(this, "max"), { passive: true });

    this.parentElement.addEventListener("mousemove", this.handleDrag.bind(this), { passive: true });
    document.addEventListener("mousemove", this.handleDrag.bind(this), { passive: true });
    document.addEventListener("mouseup", this.handleStopDrag.bind(this, null), { passive: true });
    document.addEventListener("mouseleave", this.handleStopDrag.bind(this, null), { passive: true });

    this.parentElement.addEventListener("touchmove", this.handleDrag.bind(this), { passive: true });
    this.parentElement.addEventListener("touchend", this.handleStopDrag.bind(this, null), { passive: true });

    this.setMinAndMaxValues();
    this.handleDefaultCase();

    window?.addEventListener("resize", () => {
      this.setMinAndMaxValues();
      this.handleDefaultCase();
    }, { passive: true })
  }

  handleDefaultCase() {
    const max = this.dataset.max;
    const minVal = +(this.dataset.minVal || '0');
    const maxVal = +(this.dataset.maxVal || max || '0');

    if (this.element.min?.querySelector("label") && this.clientWidth) {
      const left = ((minVal / (max || 1)) * this.clientWidth);
      this.element.min.querySelector("label").style.left = `${left}px`;
      const showPrice = this.element?.min?.querySelector("span");
      if (showPrice) {
        this.element.min.querySelector("span").innerHTML = (this.dataset.money || "0.00").replace("0.00", this.element.min.querySelector("input").value.replace(".00", ""));
      }
    }

    const maxWidth = this.clientWidth;
    if (this.element.max?.querySelector("label") && this.clientWidth) {
      const left = ((maxVal / (max || 1)) * this.clientWidth);
      this.element.max.querySelector("label").style.left = `${left > maxWidth ? maxWidth : left}px`;
      const showPrice = this.element?.max?.querySelector("span");
      if (showPrice) {
        this.element.max.querySelector("span").innerHTML = (this.dataset.money || "0.00").replace("0.00", this.element.max.querySelector("input").value.replace(".00", ""));
      }
    }
  }

  handleDrag(event) {
    if (this.dragData?.["min"]?.drag) {
      const type = "min";
      this.handleMove(type, event);
    } else if (this.dragData?.["max"]?.drag) {
      const type = "max";
      this.handleMove(type, event);
    }
  }

  handleMove(type, event) {
    const left = (event.x || event.changedTouches?.[0]?.pageX) - this.dragData[type].start;
    this.dragData[type].start = (event.x || event.changedTouches?.[0]?.pageX);
    if (this.element?.[type]?.querySelector("label")) {
      const prevLeft = this.element[type].querySelector("label").style.left ? +this.element[type].querySelector("label").style.left.replace("px", "") : type === "min" ? 0 : this.clientWidth || 0;
      let total = prevLeft + left;
      const minVal = type === "min" ? 0 : +(this.element.min?.querySelector("label")?.style?.left || '0px').replace("px", "") + 15;
      const maxVal = type === "min" ? +(this.element.max?.querySelector("label")?.style?.left || `${this.clientWidth}px`).replace("px", "") - 15 : this.clientWidth;

      if (total < minVal) {
        total = minVal;
        this.handleStopDrag(type, event);
      } else if (total > maxVal) {
        total = maxVal;
        this.handleStopDrag(type, event);
      }
      this.element[type].querySelector("label").style.left = `${total}px`;

      this.handlePriceChange(type);
    }
  }

  handleStartDrag(type, event) {
    this.dragData[type].drag = true;
    this.dragData[type].start = (event.x || event.changedTouches?.[0]?.pageX);
    this.dragData[type].pos = this.element?.[type]?.querySelector("label")?.offsetLeft;

    const container = document.getElementById("Filter_Container");
    container?.classList.add("dragging")
  }

  handleStopDrag(type, event) {
    if (!type) {
      if (this.dragData?.["min"]?.drag) {
        type = "min"
      } else if (this.dragData?.["max"]?.drag) {
        type = "max"
      } else {
        return;
      }
    }
    this.dragData[type].drag = false;
    this.dragData[type].start = (event.x || event.changedTouches?.[0]?.pageX);
    this.dragData[type].pos = this.element?.[type]?.querySelector("label")?.offsetLeft;

    if (this.element?.[type]?.querySelector("input")) {
      this.handleFilterApply(this.element[type].querySelector("input"));
    }

    const container = document.getElementById("Filter_Container");
    container?.classList.remove("dragging")
  }

  handleFilterApply(item) {
    const e = new Event("change");
    item.dispatchEvent(e);


    const e_form = new Event("input");
    const form = document.getElementById("FacetFiltersForm");
    if (form) {
      form.dispatchEvent(e_form);
    }
  }

  handlePriceChange(type) {
    const input = this.element?.[type]?.querySelector("input");
    const offset = this.element?.[type]?.querySelector("label")?.offsetLeft || 0;
    if (input) {
      const total = Math.ceil(((offset / (this.clientWidth || 1)) * (this.dataset?.max || 1)) / 100);
      this.element[type].querySelector("input").value = total;
      this.element[type].querySelector("input").setAttribute("value", total);

      const showPrice = this.element?.[type]?.querySelector("span");
      if (showPrice) {
        this.element[type].querySelector("span").innerHTML = (this.dataset.money || "0.00").replace("0.00", this.element[type].querySelector("input").value);
      }
    }
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget || event.target);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
